export default "/_next/static/images/img3-8b13bd71b896a285744f0c34c6894572.png";